import React from 'react'
import { Helmet } from 'react-helmet'
import { useRouteMatch, Switch, Route } from 'react-router-dom'

import { EuiPage, EuiPageBody } from '@elastic/eui'

import AccountDrawer from './AccountDrawer'

export const SettingsPage: React.FC = () => {
  const { path } = useRouteMatch()

  return (
    <React.Fragment>
      <Helmet>
        <title>Account Settings</title>
      </Helmet>
      <EuiPage className='euiPage--platform'>
        <EuiPageBody>
          <Switch>
            <Route exact path={path}>
              <AccountDrawer />
            </Route>
          </Switch>
        </EuiPageBody>
      </EuiPage>
    </React.Fragment>
  )
}

export default SettingsPage
